import { Mail, MessageCircle } from "lucide-react";
import { useLang, WHATSAPP_URL, EMAIL, EMAIL_URL } from "../i18n";
import { scrollToId, trackEvent } from "../lib";
import { Logo } from "./Logo";

export const Footer = () => {
  const { t } = useLang();
  const links = [
    [t.nav.ciclo, "#ciclo", "footer-link-ciclo"],
    [t.nav.atuar, "#consultoria", "footer-link-consultoria"],
    [t.nav.governanca, "#governanca", "footer-link-governanca"],
    [t.nav.pilares, "#pilares", "footer-link-pilares"],
    [t.nav.paraQuem, "#para-quem", "footer-link-para-quem"],
    [t.nav.contato, "#contato", "footer-link-contato"],
  ];

  return (
    <footer className="border-t border-line px-5 py-14 sm:px-8">
      <div className="mx-auto flex max-w-7xl flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div>
          <Logo />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-mist">{t.footer.tag}</p>
          <div className="mt-5 flex flex-wrap items-center gap-4 font-mono text-xs text-white/60">
            <a
              data-testid="footer-email"
              href={EMAIL_URL}
              onClick={() => trackEvent("email_click", { section: "footer" })}
              className="inline-flex items-center gap-2 transition-colors hover:text-volt"
            >
              <Mail size={13} />
              {EMAIL}
            </a>
            <a
              data-testid="footer-whatsapp"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              onClick={() => trackEvent("whatsapp_click", { section: "footer" })}
              className="inline-flex items-center gap-2 transition-colors hover:text-volt"
            >
              <MessageCircle size={13} />
              +55 61 98527-5734
            </a>
          </div>
        </div>
        <div className="flex flex-wrap gap-x-10 gap-y-4 font-mono text-xs uppercase tracking-widest text-white/50">
          {links.map(([label, hash, testid]) => (
            <a
              key={hash}
              data-testid={testid}
              href={hash}
              onClick={(e) => {
                e.preventDefault();
                scrollToId(hash);
              }}
              className="transition-colors hover:text-volt"
            >
              {label}
            </a>
          ))}
        </div>
      </div>
      <div className="mx-auto mt-12 flex max-w-7xl flex-col gap-3 border-t border-line pt-6 font-mono text-[11px] uppercase tracking-widest text-white/35 sm:flex-row sm:justify-between">
        <span>© {new Date().getFullYear()} Orqestria</span>
        <span>{t.footer.made}</span>
      </div>
    </footer>
  );
};
